import { Button, Card, Typography } from "@arco-design/web-react";
import { ArrowRight, Clock3 } from "lucide-react";

import { useAdminNavigation } from "./useAdminNavigation";

const { Title, Paragraph, Text } = Typography;

/**
 * 后台占位页，用于承接尚未落地的业务模块。
 */
export function AdminPlaceholderPage() {
  const navigation = useAdminNavigation();

  return (
    <div style={{ display: "grid", gap: 20 }}>
      <Card
        bodyStyle={{ padding: 28 }}
        style={{
          border: "1px solid #e5e6eb",
          borderRadius: 20,
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <div
            style={{
              display: "flex",
              height: 56,
              width: 56,
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 18,
              background: "#e8f3ff",
              color: "#165dff",
            }}
          >
            <Clock3 size={24} />
          </div>
          <div>
            <Title heading={4} style={{ margin: "0 0 8px" }}>
              {navigation.pageTitle}
            </Title>
            <Paragraph style={{ margin: 0, color: "#4e5969", fontSize: 15 }}>
              {navigation.pageDescription}
            </Paragraph>
          </div>
        </div>
      </Card>

      <Card
        bodyStyle={{ padding: 28 }}
        style={{
          border: "1px solid #e5e6eb",
          borderRadius: 20,
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
        }}
      >
        <Title heading={5} style={{ marginTop: 0 }}>
          模块建设中
        </Title>
        <Paragraph style={{ color: "#4e5969", fontSize: 15 }}>
          当前页面已接入统一后台壳层和导航体系，后续可以直接在这里接入真实业务内容、权限控制和数据接口。
        </Paragraph>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            borderRadius: 16,
            background: "#f7f8fa",
            padding: "18px 20px",
          }}
        >
          <div>
            <Text style={{ display: "block", color: "#1d2129", fontWeight: 600 }}>
              下一步建议
            </Text>
            <Text style={{ color: "#86909c" }}>补业务表单、列表页和权限细粒度控制。</Text>
          </div>
          <Button type="secondary" icon={<ArrowRight size={16} />}>
            等待业务接入
          </Button>
        </div>
      </Card>
    </div>
  );
}
